/* eslint-disable import/prefer-default-export */
import * as lc from '../../../../../utils/lodashCustom';

export function restructureSpecialPagesListItemModel(state, data) {
  return {
    id: lc.get(data, 'id'),
    title: lc.get(data, 'title'),
    title2: lc.get(data, 'title2'),
    seo_url: lc.get(data, 'seo_url'),
    lead: lc.get(data, 'lead'),
    createdAt: lc.get(data, 'created_at'),
    pageTags: lc.get(data, 'pageTags')
  };
}

export function restructureSpecialPagesModel(state, data) {
  return {
    id: lc.get(data, 'id'),
    title: lc.get(data, 'title'),
    title2: lc.get(data, 'title2'),
    seo_url: lc.get(data, 'seo_url'),
    lead: lc.get(data, 'lead'),
    content: lc.get(data, 'content'),
    metaDescription: lc.get(data, 'meta_description'),
    metaKeywords: lc.get(data, 'meta_keywords'),
    metaTitle: lc.get(data, 'meta_title'),
    createdAt: lc.get(data, 'created_at'),
    pageTags: lc.get(data, 'pageTags')
  };
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/specialPages/services/SpecialPagesService/restructuring/index.js